<svg role="img" focusable="false" [attr.aria-labelledby]="id">
  <title id="{{ id }}">{{ title ? title : icon }}</title>
  <use attr.xlink:href="/assets/svg-sprite/icons-sprite.svg?{{ id }}#{{icon}}"></use>
</svg>
<ng-content></ng-content>
